
// You can write more code here

/* START OF COMPILED CODE */

import EditorMarker from "../EditorMarker";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class CheckpointMarker extends EditorMarker {

  constructor(scene: Phaser.Scene, x?: number, y?: number, texture?: string, frame?: number | string) {
    super(scene, x ?? 40, y ?? 120, texture || "game", frame ?? "icon-panda.png");

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
